import Button from "../../Button";
import constants from "../../../constants";
import Overlay from "../../CommonComponents/Overlay";
import Checkbox from "../../CommonComponents/Checkbox";
import WarningSvgIcon from "../../../Svg/WarningSvgIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobile,
  faArrowUp,
  faMehBlank,
  faArrowLeft,
  faArrowDown,
  faUserGroup,
  faArrowRight,
  faWindowRestore,
} from "@fortawesome/free-solid-svg-icons";


const ProctoredDataDetails = ({
  getProctorData,
  showAll,
  handleSelectImage,
  deleteImages,
  handleDeleteImg,
  setShowAll,
}) => {
  return (
    <>
      <div className="proctoringImagesTitleContainer">
        <div className="proctoringImagesTitleSec">
          <div className="proctoringImagesCheckBx">
            <div className="proctoringImagesSelectAll">
              <Checkbox
                size="md"
                text="Select All"
                disabled={!getProctorData()?.length > 0}
                onChange={(checked) => handleSelectImage(checked, "all")}
                checked={
                  getProctorData()?.length === deleteImages.withKey.length
                }
              />
              {getProctorData()?.length > 0 && (
                <Button
                  size={"sm"}
                  onClick={handleDeleteImg}
                  disabled={!deleteImages.withOutKey.length > 0}
                  hierarchy={{
                    type: "primary",
                    buttonText: "Delete",
                  }}
                />
              )}
            </div>
            <div className="proctoringImagesShowViolations">
              <Checkbox
                size="md"
                text="Show Violations"
                checked={showAll}
                disabled={!getProctorData()?.length > 0}
                onChange={(checked) => setShowAll(!showAll)}
              />

              <Overlay
                title={
                  <div className="overlayInfoForProctorData">
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faMobile} />
                      <div>Mobile Detected</div>
                    </div>
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faArrowUp} />
                      <div>Upward Face Position</div>
                    </div>
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faMehBlank} />
                      <div>No Face Detected</div>
                    </div>
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faArrowLeft} />
                      <div>Leftward Face Position</div>
                    </div>
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faArrowDown} />
                      <div>Downward Face Position</div>
                    </div>
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faArrowRight} />
                      <div>Rightward Face Position</div>
                    </div>
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faUserGroup} />
                      <div>Multiple Face Detected</div>
                    </div>
                    <div className="overlayInfoForProctorDataInnerDiv">
                      <FontAwesomeIcon icon={faWindowRestore} />
                      <div>Multiple Screen Detected</div>
                    </div>
                  </div>
                }
                component={<WarningSvgIcon due="Due Today" />}
              />
            </div>
          </div>
        </div>
      </div>
      {/* {console.log("PP PP Data: ", getProctorData())} */}
      {getProctorData()?.length ? (
        <div className="ProctoringImagesContainer" /* ref={scrollRef} */>
          {getProctorData()?.map((data, index) => {
            let utcDate = new Date(data.timestamp);
            let header = "";

            let istFormatter = utcDate.toLocaleString("en-IN", {
              hour12: true,
              day: "2-digit",
              year: "numeric",
              hour: "2-digit",
              month: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });

            header = (
              <div className="proctoringImgDivHedaer">
                <span>{istFormatter}</span>
                {((data.externaldevice ?? "0") !== "0" ||
                  (data.dpexternaldevice ?? "0") !== "0") && (
                  <FontAwesomeIcon icon={faWindowRestore} />
                )}

                {data.faceorientationnormal !== 0 && (
                  <FontAwesomeIcon
                    icon={
                      data.faceorientationnormal ===
                      constants.FACE_POSITION.DOWN
                        ? faArrowDown
                        : data.faceorientationnormal ===
                          constants.FACE_POSITION.UP
                        ? faArrowUp
                        : data.faceorientationnormal ===
                          constants.FACE_POSITION.LEFT
                        ? faArrowLeft
                        : data.faceorientationnormal ===
                          constants.FACE_POSITION.RIGHT
                        ? faArrowRight
                        : data.faceorientationnormal !==
                            constants.FACE_POSITION.FORWARD && faMehBlank
                    }
                  />
                )}

                {((data.facedetected ?? 1) === 0 ||
                  (data.facedetected ?? 1) === 0) && (
                  <FontAwesomeIcon icon={faMehBlank} />
                )}

                {((data.multifacedetected ?? 0) !== 0 ||
                  (data.dpmultifacedetected ?? 0) !== 0) && (
                  <FontAwesomeIcon icon={faUserGroup} />
                )}

                {((data.phonedetected ?? "0") !== "0" ||
                  (data.dpphonedetected ?? "0") !== "0") && (
                  <FontAwesomeIcon icon={faMobile} />
                )}
              </div>
            );

            return (
              <div className="proctoringImgDiv" key={index}>
                <div className="proctoringImgTimestampSec">
                  <Checkbox
                    size="sm"
                    text={header}
                    checked={data.isChecked}
                    onChange={(checked) =>
                      handleSelectImage(
                        checked,
                        data.imagename,
                        data.dpimagename ? data.dpimagename : null
                      )
                    }
                  />
                </div>
                <div className="proctoringImgContainer">
                  <img
                    alt="proctoringFacedetected"
                    src={data.imagePresignedUrl}
                    className={
                      data.faceorientationnormal === 0
                        ? "proctoringFacedetected"
                        : "proctoringNotdetected"
                    }
                  />
                  {/* Render DP image only if available */}
                  {data.dpimagePresignedUrl && (
                    <img
                      src={data.dpimagePresignedUrl}
                      alt="dpFaceImage"
                      className="dpImage"
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <p className="proctoringTimeStamp">No proctoring data</p>
        </div>
      )}
    </>
  );
};

export default ProctoredDataDetails;
